import React from "react";

export default function GitHubAppGuide() {
  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#f9fafb',
      padding: '2rem 1rem'
    }}>
      <div style={{
        maxWidth: '800px',
        margin: '0 auto',
        backgroundColor: 'white',
        borderRadius: '8px',
        padding: '2rem',
        boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)'
      }}>
        {/* Header */}
        <div style={{ marginBottom: '2rem', textAlign: 'center' }}>
          <h1 style={{
            fontSize: '2rem',
            fontWeight: 'bold',
            color: '#1f2937',
            marginBottom: '0.5rem'
          }}>
            Guía de Instalación
          </h1>
          <p style={{ fontSize: '1.25rem', color: '#6b7280' }}>
            GitHub App BEDCEO
          </p>
        </div>

        {/* Content */}
        <div style={{
          fontSize: '0.9375rem',
          lineHeight: '1.75',
          color: '#374151'
        }}>
          {/* Introduction */}
          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#1f2937', marginBottom: '1rem' }}>
              ¿Por qué necesitas instalar la GitHub App?
            </h2>
            <p style={{ marginBottom: '1rem' }}>
              BEDCEO utiliza agentes de IA que necesitan acceso a tu repositorio de GitHub para:
            </p>
            <ul style={{ marginLeft: '1.5rem', marginBottom: '1rem' }}>
              <li><strong>Leer el código</strong> y entender el contexto del proyecto</li>
              <li><strong>Crear branches</strong> automáticamente para implementar tareas</li>
              <li><strong>Hacer commits y push</strong> con los cambios realizados</li>
              <li><strong>Crear y actualizar Pull Requests</strong> con las implementaciones completadas</li>
            </ul>
            <p style={{ marginBottom: '1rem' }}>
              La GitHub App proporciona una manera <strong>segura y controlada</strong> de otorgar estos permisos, permitiéndote:
            </p>
            <ul style={{ marginLeft: '1.5rem' }}>
              <li>✅ Elegir exactamente qué repositorios puede acceder BEDCEO</li>
              <li>✅ Revocar el acceso en cualquier momento</li>
              <li>✅ Mantener control total sobre tu código</li>
              <li>✅ Ver un registro completo de todas las acciones realizadas</li>
            </ul>
          </section>

          {/* Prerequisites */}
          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#1f2937', marginBottom: '1rem' }}>
              Requisitos Previos
            </h2>
            <p style={{ marginBottom: '0.5rem' }}>Antes de comenzar, asegúrate de tener:</p>
            <ul style={{ marginLeft: '1.5rem' }}>
              <li>✅ Una cuenta de GitHub activa</li>
              <li>✅ Permisos de administrador en el repositorio donde quieres usar BEDCEO</li>
              <li>✅ Tu repositorio debe usar el formato HTTPS: <code style={{
                backgroundColor: '#f3f4f6',
                padding: '0.125rem 0.375rem',
                borderRadius: '0.25rem',
                fontFamily: 'monospace',
                fontSize: '0.875rem'
              }}>https://github.com/usuario/repositorio</code></li>
            </ul>
          </section>

          {/* Step 1 */}
          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#1f2937', marginBottom: '1rem' }}>
              Paso 1: Acceder a la GitHub App
            </h2>
            <ol style={{ marginLeft: '1.5rem' }}>
              <li style={{ marginBottom: '0.5rem' }}>
                Visita la página de la aplicación: <a
                  href="https://github.com/apps/bedceo"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: '#2563eb', fontWeight: 'bold', textDecoration: 'underline' }}
                >
                  https://github.com/apps/bedceo
                </a>
              </li>
              <li>Verás la página de información de la GitHub App de BEDCEO</li>
            </ol>
          </section>

          {/* Step 2 */}
          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#1f2937', marginBottom: '1rem' }}>
              Paso 2: Instalar la App
            </h2>
            <ol style={{ marginLeft: '1.5rem' }}>
              <li style={{ marginBottom: '0.5rem' }}>
                Haz clic en el botón <strong>"Install"</strong> (o "Configure" si ya la instalaste previamente)
              </li>
              <li style={{ marginBottom: '0.5rem' }}>GitHub te pedirá que selecciones dónde instalar la app:</li>
              <ul style={{ marginLeft: '1.5rem', marginBottom: '0.5rem' }}>
                <li><strong>En tu cuenta personal</strong>: Para repositorios personales</li>
                <li><strong>En una organización</strong>: Si el repositorio pertenece a una organización</li>
              </ul>
              <li>Selecciona la cuenta u organización correspondiente</li>
            </ol>
          </section>

          {/* Step 3 */}
          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#1f2937', marginBottom: '1rem' }}>
              Paso 3: Configurar Permisos de Repositorios
            </h2>
            <p style={{ marginBottom: '1rem' }}>
              Aquí puedes elegir qué repositorios tendrán acceso a BEDCEO:
            </p>

            <h3 style={{ fontSize: '1.125rem', fontWeight: 'bold', color: '#374151', marginBottom: '0.5rem' }}>
              Opción A: Acceso a todos los repositorios
            </h3>
            <ul style={{ marginLeft: '1.5rem', marginBottom: '1rem' }}>
              <li>Selecciona <strong>"All repositories"</strong></li>
              <li>BEDCEO tendrá acceso a todos tus repositorios actuales y futuros</li>
              <li>Recomendado si tienes pocos repositorios</li>
            </ul>

            <h3 style={{ fontSize: '1.125rem', fontWeight: 'bold', color: '#374151', marginBottom: '0.5rem' }}>
              Opción B: Acceso selectivo (recomendado)
            </h3>
            <ul style={{ marginLeft: '1.5rem', marginBottom: '1rem' }}>
              <li>Selecciona <strong>"Only select repositories"</strong></li>
              <li>Elige específicamente los repositorios donde usarás BEDCEO</li>
              <li>Puedes agregar más repositorios después</li>
            </ul>

            <div style={{
              backgroundColor: '#f3f4f6',
              padding: '1rem',
              borderRadius: '0.5rem',
              fontFamily: 'monospace',
              fontSize: '0.875rem'
            }}>
              <div>✓ mi-proyecto-web</div>
              <div>✓ app-mobile</div>
              <div>✗ proyecto-privado-cliente</div>
            </div>
          </section>

          {/* Step 4 */}
          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#1f2937', marginBottom: '1rem' }}>
              Paso 4: Revisar y Confirmar Permisos
            </h2>
            <p style={{ marginBottom: '1rem' }}>
              La GitHub App solicitará los siguientes permisos:
            </p>

            <h3 style={{ fontSize: '1.125rem', fontWeight: 'bold', color: '#374151', marginBottom: '0.5rem' }}>
              Permisos de Lectura
            </h3>
            <ul style={{ marginLeft: '1.5rem', marginBottom: '1rem' }}>
              <li><strong>Contents</strong>: Leer el código fuente y estructura del proyecto</li>
              <li><strong>Metadata</strong>: Información básica del repositorio</li>
              <li><strong>Pull Requests</strong>: Ver PRs existentes</li>
            </ul>

            <h3 style={{ fontSize: '1.125rem', fontWeight: 'bold', color: '#374151', marginBottom: '0.5rem' }}>
              Permisos de Escritura
            </h3>
            <ul style={{ marginLeft: '1.5rem', marginBottom: '1rem' }}>
              <li><strong>Contents</strong>: Crear branches, commits y hacer push</li>
              <li><strong>Pull Requests</strong>: Crear y actualizar Pull Requests</li>
              <li><strong>Issues</strong>: Crear comentarios y actualizar issues (opcional)</li>
            </ul>

            <p>
              Revisa los permisos y haz clic en <strong>"Install"</strong> o <strong>"Install & Authorize"</strong>
            </p>
          </section>

          {/* Step 5 */}
          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#1f2937', marginBottom: '1rem' }}>
              Paso 5: Verificar la Instalación
            </h2>
            <ol style={{ marginLeft: '1.5rem' }}>
              <li>Serás redirigido de vuelta a GitHub</li>
              <li>Ve a <strong>Settings → Applications → Installed GitHub Apps</strong></li>
              <li>Deberías ver <strong>"BEDCEO"</strong> en la lista</li>
              <li>Verifica que los repositorios correctos están configurados</li>
            </ol>
          </section>

          {/* Step 6 */}
          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#1f2937', marginBottom: '1rem' }}>
              Paso 6: Configurar tu Proyecto en BEDCEO
            </h2>
            <p style={{ marginBottom: '1rem' }}>Ahora que la app está instalada:</p>
            <ol style={{ marginLeft: '1.5rem' }}>
              <li style={{ marginBottom: '0.5rem' }}>Ve a <strong>BEDCEO</strong> y crea o edita tu proyecto</li>
              <li style={{ marginBottom: '0.5rem' }}>
                En el campo <strong>"Repositorio de GitHub"</strong>, ingresa la URL HTTPS de tu repositorio:
                <div style={{
                  backgroundColor: '#f3f4f6',
                  padding: '0.75rem',
                  borderRadius: '0.375rem',
                  fontFamily: 'monospace',
                  fontSize: '0.875rem',
                  marginTop: '0.5rem'
                }}>
                  https://github.com/tu-usuario/tu-repositorio
                </div>
              </li>
              <li style={{ marginBottom: '0.5rem' }}>Completa los demás campos del formulario</li>
              <li>Guarda el proyecto</li>
            </ol>
            <p style={{
              marginTop: '1rem',
              padding: '1rem',
              backgroundColor: '#d1fae5',
              borderRadius: '0.5rem',
              fontWeight: 'bold',
              color: '#065f46'
            }}>
              ¡Listo! BEDCEO ahora puede trabajar en tu repositorio. 🎉
            </p>
          </section>

          {/* Troubleshooting */}
          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#1f2937', marginBottom: '1rem' }}>
              Solución de Problemas
            </h2>

            <div style={{ marginBottom: '1rem' }}>
              <h3 style={{ fontSize: '1.125rem', fontWeight: 'bold', color: '#374151', marginBottom: '0.5rem' }}>
                Error: "BEDCEO no puede acceder al repositorio"
              </h3>
              <p style={{ marginLeft: '1rem' }}>
                <strong>Solución:</strong>
              </p>
              <ul style={{ marginLeft: '2.5rem' }}>
                <li>Verifica que instalaste la GitHub App</li>
                <li>Confirma que el repositorio específico tiene acceso autorizado</li>
                <li>Asegúrate de usar la URL HTTPS correcta</li>
              </ul>
            </div>

            <div style={{ marginBottom: '1rem' }}>
              <h3 style={{ fontSize: '1.125rem', fontWeight: 'bold', color: '#374151', marginBottom: '0.5rem' }}>
                Error: "Permission denied" al hacer push
              </h3>
              <p style={{ marginLeft: '1rem' }}>
                <strong>Solución:</strong>
              </p>
              <ul style={{ marginLeft: '2.5rem' }}>
                <li>Revisa que la app tenga permisos de <strong>escritura</strong> en "Contents"</li>
                <li>Ve a la configuración de la app y verifica los permisos otorgados</li>
              </ul>
            </div>

            <div style={{ marginBottom: '1rem' }}>
              <h3 style={{ fontSize: '1.125rem', fontWeight: 'bold', color: '#374151', marginBottom: '0.5rem' }}>
                No puedo ver la opción para instalar la app
              </h3>
              <p style={{ marginLeft: '1rem' }}>
                <strong>Solución:</strong>
              </p>
              <ul style={{ marginLeft: '2.5rem' }}>
                <li>Verifica que tienes permisos de administrador en el repositorio</li>
                <li>Si es un repositorio de organización, contacta al owner de la organización</li>
              </ul>
            </div>
          </section>

          {/* FAQs */}
          <section style={{ marginBottom: '2rem' }}>
            <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#1f2937', marginBottom: '1rem' }}>
              Preguntas Frecuentes
            </h2>

            <div style={{ marginBottom: '1rem' }}>
              <h3 style={{ fontSize: '1.125rem', fontWeight: 'bold', color: '#374151', marginBottom: '0.5rem' }}>
                ¿Es seguro instalar esta app?
              </h3>
              <p style={{ marginLeft: '1rem' }}>
                Sí. La GitHub App sigue los estándares de seguridad de GitHub y solo solicita los permisos
                necesarios para funcionar. Puedes revisar el código fuente de BEDCEO y revocar el acceso en
                cualquier momento.
              </p>
            </div>

            <div style={{ marginBottom: '1rem' }}>
              <h3 style={{ fontSize: '1.125rem', fontWeight: 'bold', color: '#374151', marginBottom: '0.5rem' }}>
                ¿Puedo usar BEDCEO con repositorios privados?
              </h3>
              <p style={{ marginLeft: '1rem' }}>
                Sí, la GitHub App funciona tanto con repositorios públicos como privados.
              </p>
            </div>

            <div style={{ marginBottom: '1rem' }}>
              <h3 style={{ fontSize: '1.125rem', fontWeight: 'bold', color: '#374151', marginBottom: '0.5rem' }}>
                ¿Los agentes pueden modificar mi código sin mi aprobación?
              </h3>
              <p style={{ marginLeft: '1rem' }}>
                Los agentes crean Pull Requests con sus cambios. Tú mantienes el control total y puedes revisar
                cada cambio antes de hacer merge a tu rama principal.
              </p>
            </div>
          </section>

          {/* Support */}
          <section style={{
            marginTop: '3rem',
            padding: '1.5rem',
            backgroundColor: '#f9fafb',
            borderRadius: '0.5rem',
            borderLeft: '4px solid #3b82f6'
          }}>
            <h2 style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#1f2937', marginBottom: '1rem' }}>
              Soporte
            </h2>
            <p style={{ marginBottom: '0.5rem' }}>Si necesitas ayuda adicional:</p>
            <ul style={{ marginLeft: '1.5rem' }}>
              <li>📧 Email: support@bedceo.com</li>
              <li>📖 Documentación completa: <a
                href="https://docs.bedceo.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: '#2563eb', textDecoration: 'underline' }}
              >
                https://docs.bedceo.com
              </a></li>
            </ul>
          </section>

          {/* Back button */}
          <div style={{ marginTop: '2rem', textAlign: 'center' }}>
            <button
              onClick={() => window.close()}
              style={{
                padding: '0.75rem 1.5rem',
                backgroundColor: '#3b82f6',
                color: 'white',
                border: 'none',
                borderRadius: '0.375rem',
                fontSize: '0.9375rem',
                fontWeight: 'bold',
                cursor: 'pointer',
                textTransform: 'uppercase'
              }}
            >
              Cerrar Guía
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
